import { l } from '../lib/imports'
import { common } from '../main/common-sidecar'
import { layers } from '../main/layers-sidecar'
import { scene } from '../main/scene-sidecar'
import { locationGenerator } from '../tiles/locationGenerator-sidecar'
import { IButton } from '../uiParts/buttons'
import { buttons } from '../uiParts/buttons-sidecar'
import { clickEater } from '../uiParts/clickEater-sidecar'
import { IDialog } from '../uiParts/dialogs'
import { dialogs } from '../uiParts/dialogs-sidecar'

interface ISpawner {
  button: IButton
  data: ISpawnData
}
interface IData {
  isOpen: boolean
  dialog: dialogs.IDialog
  spawners: ISpawner[]
}
let _data: IData | null = null

interface ISpawnData {
  name: string
  idx: number
}

let locations = ['asteroids', 'open-space', 'wreck']

export const getData = () => {
  if (!_data) {
    let x = 20
    let y = 100
    let dialog: IDialog = dialogs.create(10, 15, x, y, 'Travel!', () => {
      setOpen(false)
    })

    _data = {
      isOpen: false,
      dialog,
      spawners: [],
    }
    setOpen(false)
  }
  return _data
}

export const toggle = () => {
  setOpen(!getData().isOpen)
}

export const setOpen = (isOpen: boolean) => {
  clickEater.update('uiTravel', isOpen)
  let data = getData()
  data.isOpen = isOpen
  dialogs.setVisible(data.dialog, isOpen)

  if (data.isOpen) {
    let travelData = l.map(locations, (c, cIdx) => {
      return {
        idx: cIdx,
        name: c,
      }
    })

    let x = data.dialog.x + 20
    let y = data.dialog.y + 50

    let ctx = scene.getContext()

    l.forEach(travelData, (c) => {
      let button = buttons.create(layers.getLayers().ui, x, y, c.name, () => {
        locationGenerator.wipeRight(ctx.mapShip)

        if (c.name === 'asteroids') {
          locationGenerator.addAsteroids(ctx.mapShip)
        }
        if (c.name === 'wreck') {
          locationGenerator.addWreck(ctx.mapShip)
        }
        setOpen(false)
      })
      data.spawners.push({
        data: c,
        button,
      })
      y += 50
    })
  }
  if (!data.isOpen) {
    l.forEach(data.spawners, (c) => {
      buttons.kill(c.button)
    })
    data.spawners = []
  }
}

export const update = () => {
  // TODO: if active
  let s = common.getPhaserScene()
  let ctx = scene.getContext()
}
